import React from "react";
import { connect } from 'react-redux';
import moment from "moment";
import ClipLoader from "react-spinners/ClipLoader";
import { Row, Col, Card, CardBody, Button, Badge, Table, Modal, Alert } from "reactstrap";
import api from "./../../../Api.js";
import { parseHolidayFile, modeloCsv, modeloJson } from "./../../../helper/importHolidays.js";

//formatos aceitos, com o filtro do seletor de arquivo de cada um
const FORMATOS = [
    { id: "json", nome: "JSON", icone: "fas fa-code", accept: ".json", ajuda: "Lista de objetos com descricao, inicio e fim" },
    { id: "csv", nome: "CSV", icone: "fas fa-file-csv", accept: ".csv,.txt,.tsv", ajuda: "Separado por ; ou , (exportado do Excel ou Sheets)" },
    { id: "xlsx", nome: "XLSX", icone: "fas fa-file-excel", accept: ".xlsx,.xls,.xlsm", ajuda: "Planilha do Excel ou do Google Sheets" }
];

class ModalImportHolidays extends React.Component {

    constructor(props){

        super(props);

        this.state = {

            formato: "",
            arquivo: "",
            lendo: false,
            enviando: false,
            erro: "",
            holidays: [],
            resultado: undefined

        };

        this.escolherArquivo = this.escolherArquivo.bind(this);
        this.lerArquivo = this.lerArquivo.bind(this);
        this.importar = this.importar.bind(this);
        this.baixarModelo = this.baixarModelo.bind(this);
        this.limpar = this.limpar.bind(this);

        window.modalimportholidays = this;

    }

    limpar(){

        this.setState({ formato: "", arquivo: "", holidays: [], erro: "", resultado: undefined, lendo: false, enviando: false });

    }

    //abre o seletor de arquivo já filtrado pelo formato escolhido
    escolherArquivo(formato){

        this.setState({ formato: formato.id, erro: "", holidays: [], resultado: undefined });

        var input = document.getElementById("input_import_holidays");
        if(input === null){ return false; }

        input.value = "";
        input.setAttribute("accept", formato.accept);
        input.click();

    }

    //lê e valida o arquivo no navegador, antes de enviar
    async lerArquivo(event){

        var arquivos = event.target.files;
        if(arquivos === undefined || arquivos.length === 0){ return false; }

        this.setState({ lendo: true, erro: "", holidays: [], arquivo: arquivos[0].name });

        try {

            var resultado = await parseHolidayFile(arquivos[0]);

            if(resultado.holidays.length === 0){

                this.setState({ lendo: false, erro: "Não encontramos nenhum feriado no arquivo. Confira se ele tem as colunas descrição, início e fim." });
                return false;

            }

            this.setState({ lendo: false, formato: resultado.formato, holidays: resultado.holidays });

        }catch(error){

            console.log(error);
            this.setState({ lendo: false, erro: (error.message !== undefined) ? error.message : "Não foi possível ler o arquivo." });

        }

    }

    //envia só as linhas válidas
    async importar(){

        var validos = this.state.holidays.filter(function(holiday){ return holiday.erro === ""; });
        if(validos.length === 0){ return false; }

        var enviar = validos.map(function(holiday){

            return { description: holiday.description, startDate: holiday.startDate, endDate: holiday.endDate };

        });

        this.setState({ enviando: true, erro: "" });

        await api.importHolidays({ holidays: enviar }).then((res) => {

            this.setState({ enviando: false, resultado: res.data, holidays: [] });

            //a tela de feriados recarrega a lista com o que voltou
            if(this.props.successImport !== undefined){ this.props.successImport(res.data); }

        }).catch(error => {

            console.log(error);
            this.setState({ enviando: false });
            if(error.response !== undefined && error.response.data !== undefined){ this.setState({ erro: error.response.data.msg }); }

        });

    }

    //gera o modelo no navegador para a unidade baixar e preencher
    baixarModelo(tipo){

        var conteudo = (tipo === "json") ? modeloJson() : modeloCsv();
        var mime = (tipo === "json") ? "application/json;charset=utf-8" : "text/csv;charset=utf-8";
        var nome = (tipo === "json") ? "modelo-feriados.json" : "modelo-feriados.csv";

        //BOM no CSV para o Excel abrir os acentos corretamente
        var partes = (tipo === "json") ? [conteudo] : ["﻿" + conteudo];

        var blob = new Blob(partes, { type: mime });
        var url = URL.createObjectURL(blob);

        var link = document.createElement("a");
        link.href = url;
        link.download = nome;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

    }

    render(){

        const translate = this.props.translate;

        var validos = this.state.holidays.filter(function(holiday){ return holiday.erro === ""; });
        var invalidos = this.state.holidays.filter(function(holiday){ return holiday.erro !== ""; });

        return(<Modal className="modal-dialog-centered" size="lg" isOpen={this.props.isOpen} toggle={() => this.props.close()}>

            <div className="modal-header">
                <h5 className="modal-title">{translate['importar_feriados'] || "Importar feriados e recessos"}</h5>
                <button aria-label="Close" className="close" type="button" onClick={() => this.props.close()}><span aria-hidden={true}>×</span></button>
            </div>

            <div className="modal-body">

                {/* o input fica escondido: quem abre é o botão do formato escolhido */}
                <input id="input_import_holidays" type="file" style={{ display: "none" }} onChange={(event) => this.lerArquivo(event)} />

                {(this.state.erro) && <Alert color="danger"><strong>{translate['ops'] || "Ops"}!</strong> {this.state.erro}</Alert>}

                {/* ------- resultado da importação ------- */}
                {(this.state.resultado !== undefined) &&
                    <React.Fragment>
                        <Alert color="success">
                            <strong>{this.state.resultado.msg}</strong>
                            {(this.state.resultado.duplicated > 0) &&
                                <div><small>{this.state.resultado.duplicated} {(this.state.resultado.duplicated === 1) ? "já estava cadastrado e foi ignorado" : "já estavam cadastrados e foram ignorados"}.</small></div>
                            }
                            {(this.state.resultado.errors !== undefined && this.state.resultado.errors.length > 0) &&
                                <div><small>{this.state.resultado.errors.length} {(this.state.resultado.errors.length === 1) ? "linha foi recusada" : "linhas foram recusadas"} pelo servidor.</small></div>
                            }
                        </Alert>
                        <div className="text-center">
                            <Button color="secondary" type="button" onClick={() => this.limpar()}>{translate['importar_outro'] || "Importar outro arquivo"}</Button>
                            <Button color="primary" type="button" onClick={() => this.props.close()}>{translate['fechar'] || "Fechar"}</Button>
                        </div>
                    </React.Fragment>
                }

                {/* ------- escolha do formato ------- */}
                {(this.state.resultado === undefined && this.state.holidays.length === 0) &&
                    <React.Fragment>

                        <p className="text-muted">
                            {translate['importar_feriados_ajuda'] || "Escolha o formato do seu arquivo. As colunas esperadas são descrição, início e fim (o fim fica vazio quando o feriado é de um dia só)."}
                        </p>

                        <Row>
                            {FORMATOS.map((formato, index) => (
                                <Col md="4" key={index} className="mb-3">
                                    <Card
                                        className="shadow-sm h-100"
                                        style={{ cursor: "pointer", border: (this.state.formato === formato.id) ? "2px solid #5e72e4" : "1px solid #e9ecef" }}
                                        onClick={() => this.escolherArquivo(formato)}
                                        title={formato.ajuda}
                                    >
                                        <CardBody className="text-center py-4">
                                            <i className={formato.icone} style={{ fontSize: "28px", color: "#5e72e4" }} />
                                            <h4 className="mt-2 mb-1">{formato.nome}</h4>
                                            <small className="text-muted">{formato.ajuda}</small>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        {(this.state.lendo) && <center><ClipLoader color="#adb5bd" size={30} /></center>}

                        <hr className="my-3" />

                        <Row className="align-items-center">
                            <Col md="7">
                                <small className="text-muted">{translate['baixar_modelo_ajuda'] || "Não sabe como montar o arquivo? Baixe um modelo, preencha e importe."}</small>
                            </Col>
                            <Col md="5" className="text-md-right">
                                <Button size="sm" color="secondary" type="button" onClick={() => this.baixarModelo("csv")}>
                                    <i className="fas fa-download mr-1" />CSV
                                </Button>
                                <Button size="sm" color="secondary" type="button" onClick={() => this.baixarModelo("json")}>
                                    <i className="fas fa-download mr-1" />JSON
                                </Button>
                            </Col>
                        </Row>

                    </React.Fragment>
                }

                {/* ------- pré-visualização ------- */}
                {(this.state.resultado === undefined && this.state.holidays.length > 0) &&
                    <React.Fragment>

                        <Row className="align-items-center mb-3">
                            <Col md="8">
                                <strong>{this.state.arquivo}</strong>{' '}
                                <Badge color="info">{String(this.state.formato).toUpperCase()}</Badge>
                                <div>
                                    <small className="text-muted">
                                        {validos.length} {(validos.length === 1) ? "feriado pronto para importar" : "feriados prontos para importar"}
                                        {(invalidos.length > 0) && <span className="text-danger">{' '}· {invalidos.length} com problema {(invalidos.length === 1) ? "(será ignorada)" : "(serão ignoradas)"}</span>}
                                    </small>
                                </div>
                            </Col>
                            <Col md="4" className="text-md-right">
                                <Button size="sm" color="link" type="button" onClick={() => this.limpar()}>{translate['trocar_arquivo'] || "Trocar arquivo"}</Button>
                            </Col>
                        </Row>

                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                            <Table className="align-items-center table-flush" responsive size="sm">
                                <thead className="thead-light">
                                    <tr>
                                        <th>#</th>
                                        <th>{translate['descricao'] || "Descrição"}</th>
                                        <th>{translate['inicio'] || "Início"}</th>
                                        <th>{translate['fim'] || "Fim"}</th>
                                        <th>{translate['situacao'] || "Situação"}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.holidays.map((holiday, index) => (
                                        <tr key={index} className={(holiday.erro !== "") ? "table-danger" : ""}>
                                            <td>{index + 1}</td>
                                            <td>{holiday.description || <small className="text-muted">(vazio)</small>}</td>
                                            <td>{(holiday.startDate !== "") ? moment(holiday.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : <small className="text-muted">—</small>}</td>
                                            <td>{(holiday.endDate !== "") ? moment(holiday.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : <small className="text-muted">—</small>}</td>
                                            <td>
                                                {(holiday.erro === "")
                                                    ? <Badge color="success">ok</Badge>
                                                    : <small className="text-danger">{holiday.erro}</small>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>

                        <div className="text-center mt-3">
                            <Button color="default" type="button" onClick={() => this.props.close()}>{translate['cancelar'] || "Cancelar"}</Button>
                            <Button color="primary" type="button" disabled={validos.length === 0 || this.state.enviando} onClick={() => this.importar()}>
                                {this.state.enviando
                                    ? <ClipLoader color="#fff" size={15} />
                                    : <React.Fragment>{translate['importar'] || "Importar"} {validos.length}</React.Fragment>
                                }
                            </Button>
                        </div>

                    </React.Fragment>
                }

            </div>

        </Modal>)

    }

}

export default connect(state => ({

    languages: state.language,
    translate: state.translate,
    accesslevel: state.accesslevel,
    permission: state.permission,
    user: state.user,

}))(ModalImportHolidays);
